<template>
    <div class="customerMain" id="bigdata">
        <div class="customerTop">
            <img src="../assets/imgs/topTitle.png" alt="" srcset="" />
            <div class="titleFirst"></div>
            <div class="titleSecond"></div>
            <h1>{{ this.$store.state.info.orgName }}助餐系统可视化平台</h1>
        </div>
        <div class="quanp">
            <el-button id="fullScreen" @click="showFullScreen" type="primary">
                {{ onFullScreen ? "退出全屏" : "进入全屏" }}
            </el-button>
        </div>
        <!-- <div class="visualizedTop"></div> -->
        <div class="visualizedMiddle">
            <div class="visualizedLeft">
                <div class="visualizedTitle">
                    <p class="defaultTitle">
                        <span class="name">登记信息</span>
                    </p>
                </div>
                <div class="registerBox">
                    <div class="registerLeft" @click="elderlyDetails">
                        <p class="muns">{{ oldInfo.totalCount }}</p>
                        <p class="name">老人总数</p>
                    </div>
                    <div class="registerRight">
                        <ul>
                            <li>
                                <p class="name">70岁以下</p>
                                <p class="nums nums1">{{ oldInfo.level1 }}</p>
                            </li>
                            <li>
                                <p class="name">70-80岁</p>
                                <p class="nums nums2">{{ oldInfo.level2 }}</p>
                            </li>
                            <li>
                                <p class="name">80-90岁</p>
                                <p class="nums nums4">{{ oldInfo.level3 }}</p>
                            </li>
                            <li>
                                <p class="name">90岁以上</p>
                                <p class="nums nums3">{{ oldInfo.level4 }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="visualizedTitle">
                    <p class="defaultTitle">
                        <span class="name">视频安全监督</span>
                    </p>
                </div>
                <div class="videoBox">
                    <div
                        class="videoItem"
                        v-for="(item, index) in this.vodelist"
                        :key="index"
                    >
                        <!-- <iframe
                            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/G47645614/1.live&autoplay=1&audio=1&accessToken=${this.control}&templete=2`"
                            class="ysopen"
                            allowfullscreen
                        >
                        </iframe> -->
                        <iframe
                            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${item.sequence}/${item.channel}.live&autoplay=1&audio=1&accessToken=${item.token}&templete=2`"
                            class="ysopen"
                            allowfullscreen
                        >
                        </iframe>
                        <!-- <p>食堂</p> -->
                    </div>
                    <!-- <div class="videoItem">
                        <iframe
                            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/G47645614/5.live&autoplay=1&audio=1&accessToken=${this.control}&templete=2`"
                            class="ysopen"
                            allowfullscreen
                        >
                        </iframe>
                        <p>厨房</p>
                    </div>
                    <div class="videoItem">
                        <iframe
                            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/G47645614/2.live&autoplay=1&audio=1&accessToken=${this.control}&templete=2`"
                            class="ysopen"
                            allowfullscreen
                        >
                        </iframe>
                    </div>  -->
                    <!-- <div class="clearBoth"></div> -->
                </div>
                <div class="visualizedTitle">
                    <p class="defaultTitle">
                        <span class="name">助餐政策</span>
                    </p>
                </div>
                <div class="policyBox">
                    <ul>
                        <!-- <li><span>百岁老人免单，政府全额补贴</span></li> -->
                        <li>
                            <!-- {{ zcpolicy }} -->
                            <el-input
                                type="textarea"
                                disabled
                                :autosize="{ minRows: 2, maxRows: 6 }"
                                placeholder="请输入内容"
                                v-model="zcpolicy"
                            >
                            </el-input>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="visualizedCenter">
                <div class="visualizedMeals">
                    <div class="mealItem">
                        <p class="mealTitle">早餐</p>
                        <p class="mealNums" v-if="breakfast.length > 0">
                            <span
                                v-for="(item, index) in breakfast"
                                :key="index"
                            >
                                {{ item }}
                            </span>
                        </p>
                        <p class="mealNums" v-else>
                            <span>0</span>
                        </p>
                    </div>
                    <div class="mealItem">
                        <p class="mealTitle">午餐</p>
                        <p class="mealNums" v-if="lunch.length > 0">
                            <span v-for="(item, index) in lunch" :key="index">
                                {{ item }}
                            </span>
                            <!-- <span>{{threeMeals.lunch}}</span> -->
                        </p>
                        <p class="mealNums" v-else>
                            <span>0</span>
                        </p>
                    </div>
                    <div class="mealItem">
                        <p class="mealTitle">晚餐</p>
                        <p class="mealNums" v-if="dinner.length > 0">
                            <span v-for="(item, index) in dinner" :key="index">
                                {{ item }}
                            </span>
                        </p>
                        <p class="mealNums" v-else>
                            <span>0</span>
                        </p>
                    </div>
                </div>
                <div id="serveMap" class="serveMap">
                    <p class="perNamesss" v-if="oldNums > 0">
                        {{ oldNums }}位老人
                    </p>
                    <p class="perNamess1" v-if="oldNums > 0" @click="cancel">
                        取消范围
                    </p>
                    <p class="perNamess" @click="diningRecord">就餐记录</p>
                </div>
            </div>
            <div class="visualizedRight">
                <!-- 办卡类型 -->
                <div class="visualizedTitle">
                    <p class="defaultTitle">
                        <span class="name">办卡类型</span>
                    </p>
                </div>
                <div class="visualizedCard">
                    <div class="cardItem">
                        <p class="cardNum">{{ cardInfo.limitCard }}</p>
                        <p class="cardName">限次卡</p>
                    </div>
                    <div class="cardItem">
                        <p class="cardNum">{{ cardInfo.standCard }}</p>
                        <p class="cardName">标准卡</p>
                    </div>
                </div>
                <div class="visualizedTitle">
                    <p class="defaultTitle">
                        <span
                            class="visualizedTab"
                            :class="
                                visualizedIndex == 0 ? 'visualizedTabCur' : ''
                            "
                            @click="visualizedTap(0)"
                            >今日菜品</span
                        >
                        <span class="visualizedTabLine"></span>
                        <span
                            class="visualizedTab"
                            :class="
                                visualizedIndex == 1 ? 'visualizedTabCur' : ''
                            "
                            @click="visualizedTap(1)"
                            >服务风采</span
                        >
                    </p>
                </div>
                <div class="visualizedTabBox">
                    <div class="varietyMain" v-if="visualizedIndex == 0">
                        <div class="varietyItem">
                            <div class="varietyLeft">
                                <p class="name">早餐</p>
                                <p class="price">￥{{ breakfastPrice }}</p>
                            </div>
                            <!-- <div class="varietyRight" title="水煮蛋,鲜肉包,青菜包,小米粥">水煮蛋,鲜肉包,青菜包,小米粥</div> -->
                            <div class="varietyRight" :title="breakMenu">
                                {{ breakMenu }}
                            </div>
                        </div>
                        <div class="varietyItem">
                            <div class="varietyLeft">
                                <p class="name">午餐</p>
                                <p class="price">￥{{ lunchPrice }}</p>
                            </div>
                            <div class="varietyRight" :title="this.lunchMeun">
                                {{ this.lunchMeun }}
                            </div>
                        </div>
                        <div class="varietyItem">
                            <div class="varietyLeft">
                                <p class="name">晚餐</p>
                                <p class="price">￥{{ dinnerPrice }}</p>
                            </div>
                            <div class="varietyRight" :title="this.dinnerMeun">
                                {{ this.dinnerMeun }}
                            </div>
                        </div>
                    </div>
                    <div class="serveMain" v-if="visualizedIndex == 1">
                        <el-carousel indicator-position="none" :interval="3000">
                            <el-carousel-item
                                v-for="item in styleUrl"
                                :key="item.id"
                            >
                                <img :src="item.photo" alt="" />
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
                <div class="visualizedTitle">
                    <p class="defaultTitle">
                        <span class="name">老人调查</span>
                    </p>
                </div>
                <p class="examineTab">
                    <span
                        @click="examineTap(0)"
                        :class="examineIndex == 0 ? 'examineCur' : ''"
                        >就餐需求</span
                    >
                    <span
                        @click="examineTap(1)"
                        :class="examineIndex == 1 ? 'examineCur' : ''"
                        >上门送餐</span
                    >
                    <span
                        @click="examineTap(2)"
                        :class="examineIndex == 2 ? 'examineCur' : ''"
                        >日常餐饮</span
                    >
                </p>
                <div class="examineBox">
                    <div
                        id="mealOrder"
                        class="mealFrame"
                        v-if="examineIndex == 0"
                    ></div>
                    <div
                        id="mealSend"
                        class="mealFrame"
                        v-if="examineIndex == 1"
                    ></div>
                    <div
                        id="mealDays"
                        class="mealFrame"
                        v-if="examineIndex == 2"
                    ></div>
                </div>
            </div>
        </div>
        <!-- 弹窗 -->
        <div class="maskOpen" v-if="isMask">
            <div class="maskContent">
                <ul>
                    <li @click="areaTap(500)">500米</li>
                    <li @click="areaTap(1000)">1000米</li>
                </ul>
            </div>
        </div>
        <div class="perInfoBox" v-if="isMasks">
            <div
                class="info-txt"
                style="margin-top: 12%; background: rgba(10, 88, 160, 0.8)"
            >
                <div style="width: 100%">
                    <p class="intitle" style="background: #4a79fd">
                        <span style="margin-left: 10px"> 老人明细</span>
                    </p>
                    <span class="close-info" @click="svsd">×</span>
                </div>
                <div class="info-item" style="border: 0">
                    <el-form
                        :model="queryInfo"
                        label-width="90px"
                        class="lable"
                    >
                        <el-row type="flex" justify="start">
                            <el-col :span="7">
                                <el-form-item label="姓名：">
                                    <el-input
                                        size="small"
                                        v-model="queryInfo.customerName"
                                        clearable
                                        placeholder="请输入"
                                        style="width: 100%"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="老人类别：">
                                    <el-select
                                        v-model="queryInfo.customerType"
                                        clearable
                                        size="small"
                                        popper-class="select"
                                    >
                                        <el-option
                                            value="1"
                                            label="70周岁以下"
                                        ></el-option>
                                        <el-option
                                            value="2"
                                            label="70周岁以上"
                                        ></el-option>
                                        <el-option
                                            value="3"
                                            label="80周岁以上"
                                        ></el-option>
                                        <el-option
                                            value="4"
                                            label="90周岁以上"
                                        ></el-option>
                                        <el-option
                                            value="5"
                                            label="100周岁以上"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" :offset="1">
                                <el-button
                                    type="primary"
                                    size="small"
                                    style="margin-top: 3px"
                                    @click="QueryInfo"
                                    >查询</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div
                    style="background-color: #162a5b; margin: 0px 10px"
                    class="tableBox"
                >
                    <el-table
                        bgcolor="#01117b"
                        height="542"
                        border
                        style="width: 100%; height: 540px"
                        :data="tableData"
                    >
                        <el-table-column
                            label="序号"
                            type="index"
                            width="70"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="姓名"
                            prop="customerName"
                            width="100"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="老人类别"
                            align="center"
                            :show-overflow-tooltip="true"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.customerType == 1"
                                    >70周岁以下</span
                                >
                                <span v-if="scope.row.customerType == 2"
                                    >70周岁以上</span
                                >
                                <span v-if="scope.row.customerType == 3"
                                    >80周岁以上</span
                                >
                                <span v-if="scope.row.customerType == 4"
                                    >90周岁以上</span
                                >
                                <span v-if="scope.row.customerType == 5"
                                    >100周岁以上</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="手机号"
                            :show-overflow-tooltip="true"
                            prop="phone"
                            width="110"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="卡号"
                            prop="zcCard"
                            align="center"
                        ></el-table-column>
                        <el-table-column label="卡类" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ruleType == 1"
                                    >限次卡</span
                                >
                                <span v-if="scope.row.ruleType == 2"
                                    >标准卡</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="卡号状态" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.cardStatus == 0"
                                    >未挂失</span
                                >
                                <span v-if="scope.row.cardStatus == 1"
                                    >已挂失</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="用户状态" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.userStatus == 0"
                                    >已启用</span
                                >
                                <span v-if="scope.row.userStatus == 1"
                                    >未启用</span
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="bottom-page">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        class="bottompage"
                        :background="isBackground"
                        :page-sizes="[10, 20, 40, 100]"
                        :page-size="query.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="query.totol"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <div class="perInfoBoxs" v-if="perInfoBoxs">
            <div
                class="info-txt2"
                style="margin-top: 12%; background: rgba(10, 88, 160, 0.8)"
            >
                <div style="width: 100%">
                    <p class="intitle" style="background: #4a79fd">
                        <span style="margin-left: 10px">老人信息</span>
                    </p>
                    <span class="close-info" @click="close">×</span>
                </div>
                <div class="info-item2">
                    <p style="font-size: 22px">基本信息</p>
                    <div
                        style="
                            width: 100%;
                            height: 200px;
                            background: #1739a0;
                            display: flex;
                        "
                    >
                        <div style="width: 80%">
                            <p
                                style="
                                    margin-top: 10px;
                                    margin-left: 20px;
                                    font-size: 15pt;
                                "
                            >
                                <span style=""
                                    ><label for=""
                                        >姓名：{{ addForm.customerName }}</label
                                    ></span
                                >
                                <span style="margin-left: 20px"
                                    ><label for="">性别：</label>
                                    <span v-if="addForm.gender == 1">男</span>
                                    <span v-else-if="addForm.gender == 2"
                                        >女</span
                                    >
                                    <span v-else>未知</span>
                                </span>
                                <span style="margin-left: 20px"
                                    ><label for="">手机号：</label
                                    >{{ addForm.phone }}</span
                                >
                            </p>
                            <p
                                style="
                                    margin-top: 10px;
                                    margin-left: 20px;
                                    font-size: 20px;
                                "
                            >
                                <span style=""
                                    ><label for="">身份证号：</label
                                    >{{ addForm.idCard }}</span
                                >
                                <span style="margin-left: 20px"
                                    ><label for="">用户卡号：</label
                                    >{{ addForm.zcCard }}</span
                                >
                            </p>
                            <p
                                style="
                                    margin-top: 10px;
                                    margin-left: 20px;
                                    font-size: 20px;
                                "
                            >
                                <span style=""
                                    ><label for="">用户卡类：</label>
                                    <span v-if="addForm.ruleType == 1"
                                        >限次卡</span
                                    >
                                    <span v-else-if="addForm.ruleType == 2"
                                        >标准卡</span
                                    >
                                    <span v-else>{{ addForm.ruleType }}</span>
                                </span>
                                <span style="margin-left: 20px"
                                    ><label for="">用户现金：</label
                                    >{{ addForm.chargeMoney }}</span
                                >
                                <span style="margin-left: 20px"
                                    ><label for="">卡号状态：</label>
                                    <span v-if="addForm.cardStatus == 0"
                                        >未挂失</span
                                    >
                                    <span v-else-if="addForm.cardStatus == 1"
                                        >已挂失</span
                                    >
                                    <span v-else>{{ addForm.cardStatus }}</span>
                                </span>
                            </p>
                            <p
                                style="
                                    margin-top: 10px;
                                    margin-left: 20px;
                                    font-size: 20px;
                                "
                            >
                                <span style=""
                                    ><label for="">用户状态：</label>
                                    <span v-if="addForm.userStatus == 0"
                                        >已启用</span
                                    >
                                    <span v-else-if="addForm.userStatus == 1"
                                        >未启用</span
                                    >
                                    <span v-else>{{ addForm.userStatus }}</span>
                                </span>
                                <span style="margin-left: 20px"
                                    ><label for="">到期日期：</label
                                    >{{ addForm.expireTime }}</span
                                >
                            </p>
                        </div>
                        <div style="width: 18%; padding: 2%">
                            <img
                                style="width: 100%; height: 100%"
                                src="../assets/img/user.png"
                                alt=""
                            />
                        </div>
                    </div>
                    <p style="font-size: 22px; margin: 10px 0">就餐情况</p>
                    <div
                        style="
                            width: 100%;
                            height: 210px;
                            background: #1739a0;
                            color: #d5eaff;
                            display: flex;
                        "
                    >
                        <div class="weekBox">
                            <div class="weekTop" style="font-size: 20px">
                                <P class="weekItem">就餐日期</P>
                                <P class="weekItem">就餐类别</P>
                                <P class="weekItem">就餐金额</P>
                                <P class="weekItem">就餐时间</P>
                            </div>
                            <div style="height: 150px; overflow-y: auto">
                                <div
                                    style="font-size: 16px"
                                    class="weekTops"
                                    v-for="(item, index) in findLists"
                                    :key="index"
                                >
                                    <P class="weekItem">{{
                                        item.consumeDay
                                    }}</P>
                                    <P class="weekItem">{{ item.mealType }}</P>
                                    <P class="weekItem">￥{{ item.money }}</P>
                                    <P class="weekItem">{{
                                        item.consumeTime
                                    }}</P>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="perInfoBoxs" v-if="eatRecord">
            <div
                class="info-txt2"
                style="margin-top: 12%; background: rgba(10, 88, 160, 0.8)"
            >
                <div style="width: 100%">
                    <p class="intitle" style="background: #4a79fd">
                        <span style="margin-left: 10px">就餐记录</span>
                    </p>
                    <span class="close-info" @click="close">×</span>
                </div>
                <div class="height:650px">
                    <div id="myChart1"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import request2 from "@/utils/request2.js"
import baseURL from "@/api/baseURL"
import { post } from "@/api/requrestHttp"
export default {
    data() {
        return {
            findLists: [],
            perInfoBoxs: false,
            isBackground: true,
            query: {
                pageNo: 1,
                pageSize: 10,
                totol: 0,
            },
            tableData: [],
            queryInfo: {},
            isMasks: false,
            oldNums: 0,
            onFullScreen: false,
            normalInfo: {},
            myMap: null,
            isMap: true,
            polygons: [],
            polygon: [],
            marker: [], //地图标记点
            markers: [],
            styleUrl: [],
            recMap: null,
            recIsMap: true,
            // breakfast: ["0", "4", "0"],
            // lunch: ["1", "6", "2"],
            // dinner: ["0", "5", "3"],
            breakfast: [],
            lunch: [],
            dinner: [],
            visualizedIndex: 0,
            examineIndex: 0,
            oldInfo: {
                level1: "",
                level2: "",
                level3: "",
                level4: "",
                totalCount: "",
            },
            cardInfo: {
                limitCard: "",
                standCard: "",
            },
            control: "",
            accessKey: "1fb320d32d6b4ccc87463d4dc0ae7e9a",
            accessSecret: "740d415c06c9e3f48f6123a144dc5458",
            circles: null,
            isMask: false,
            menulist: [],
            intervalId: 0,
            threeMeals: {},
            menulist: [],
            breakMenu: "",
            lunchMeun: "",
            dinnerMeun: "",
            addForm: {},
            eatRecord: false,
            dinnerPrice: "",
            lunchPrice: "",
            breakfastPrice: "",
            zcpolicy: "",
            vodelist: [
                {
                    sequence: "1",
                    channel: "1",
                    token: "1",
                },
                {
                    sequence: "1",
                    channel: "1",
                    token: "1",
                },
                {
                    sequence: "1",
                    channel: "1",
                    token: "1",
                },
            ],
        }
    },
    created() {
        //  this.ThreeMeals()
        //  this.showToday()
        // 就餐需求
        this.getMealSport()
        // 上门送餐
        // this.getMealDelivery()
        // 日常餐饮
        // this.getMealEat();
        //年龄段老人
        this.getOlds()
        // 卡类型
        this.getCard()
        this.getvode()
        this.getMeal()
        this.getPrice()
        this.getPolicy()
        this.ThreeMeals()
    },
    async mounted() {
        const self = this

        // 地图初始化
        await self.loadmap().then(() => {
            // 老人打点
            this.getLao()
        })
        this.timer = setInterval(() => {
            this.ThreeMeals()
        }, 300000)
        // 监听全屏问题
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {
        ThreeMeals() {
            this.$http
                .request({
                    url: "/sqyl/consumeRecord/info/findMealCount",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    if (res.code == 200) {
                        // setTimeout(async() => {
                        //   await this.$nextTick(() => {
                        let aa = []
                        while (res.content.lunch) {
                            aa.unshift(res.content.lunch % 10)
                            res.content.lunch = parseInt(res.content.lunch / 10)
                        }
                        this.lunch = aa
                        let bb = []
                        while (res.content.dinner) {
                            bb.unshift(res.content.dinner % 10)
                            res.content.dinner = parseInt(
                                res.content.dinner / 10
                            )
                        }
                        this.dinner = bb
                        let cc = []
                        while (res.content.breakfast) {
                            cc.unshift(res.content.breakfast % 10)
                            res.content.breakfast = parseInt(
                                res.content.breakfast / 10
                            )
                        }
                        this.breakfast = cc
                        // console.log(
                        //     bb,
                        //     cc,
                        //     res.content.breakfast,
                        //     res.content.dinner,
                        //     "Asdas"
                        // )
                        //   })
                        // },5000)
                    }
                })
        },
        showToday() {
            const self = this
            let params = {}
            request({
                url: "/sqyl/admin/weeklyMenu/findTodayFoodList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content) {
                        this.menulist = res.content
                    }
                }
            })
        },
        // 老人
        getLao() {
            const self = this
            request({
                url: "/sqyl/sxt/info/findList",
                method: "POST",
                data: { pageSize: -1, pageNo: 1 },
            }).then((res) => {
                // console.log(res.content, "老人")
                if (res.content == null) {
                    return
                }
                let datas = []
                res.content.list.forEach((item) => {
                    if (
                        item.customerType == "1" &&
                        item.latitude &&
                        item.latitude
                    ) {
                        datas.push({
                            id: item.id,
                            latitude: item.latitude,
                            longitude: item.longitude,
                            icon: require("../assets/imgs/70.png"),
                        })
                    } else if (
                        item.customerType == "2" &&
                        item.latitude &&
                        item.latitude
                    ) {
                        datas.push({
                            id: item.id,
                            latitude: item.latitude,
                            longitude: item.longitude,
                            icon: require("../assets/imgs/80.png"),
                        })
                    } else if (
                        item.customerType == "3" &&
                        item.latitude &&
                        item.latitude
                    ) {
                        datas.push({
                            id: item.id,
                            latitude: item.latitude,
                            longitude: item.longitude,
                            icon: require("../assets/imgs/90.png"),
                        })
                    } else if (
                        item.customerType == "4" &&
                        item.latitude &&
                        item.latitude
                    ) {
                        datas.push({
                            id: item.id,
                            latitude: item.latitude,
                            longitude: item.longitude,
                            icon: require("../assets/imgs/100.png"),
                        })
                    }
                })
                // console.log(datas)
                self.renderMapMarker(datas)
                // self.cardInfo=res.content;
            })
        },
        // 集中打点
        renderMapMarker(data) {
            const self = this
            let marker = null
            data.forEach((item) => {
                marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: new AMap.Icon({
                        image: item.icon,
                        size: new AMap.Size(52, 52), //图标大小
                        imageSize: new AMap.Size(24, 34),
                    }),
                    // title: item.detailAddress,

                    offset: new AMap.Pixel(-13, -30), //往左往上
                })
                self.markers.push(marker)
                marker.on("click", (e) => {
                    this.perInfoBoxs = true
                    // console.log(data)
                    request({
                        url: "/sqyl/consumeRecord/info/findMealById",
                        method: "POST",
                        data: { id: item.id },
                    }).then((res) => {
                        if (res.code == 200) {
                            if (res.content) {
                                // console.log(res.content)
                                this.findLists = res.content
                            }
                        }
                    })
                    request({
                        url: "/sqyl/sxt/info/get",
                        method: "POST",
                        data: { id: item.id },
                    }).then((res) => {
                        if (res.code == 200) {
                            if (res.content) {
                                // console.log(res.content)
                                this.addForm = res.content
                            }
                        }
                    })
                })
            })
            self.myMap.add(self.markers)
            self.myMap.setFitView(self.markers)
            self.potintMap()
        },
        // 打点
        potintMap() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {}
            self.marker = new AMap.Marker({
                icon: new AMap.Icon({
                    image: require("../assets/imgs/sign.png"),
                    size: new AMap.Size(52, 52), //图标大小
                    imageSize: new AMap.Size(26, 36),
                }),
                position: [118.326149, 29.720121],
            })
            self.marker.on("click", self.openMask)
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        // 弹窗
        openMask() {
            this.isMask = true
        },
        areaTap(num) {
            this.isMask = false
            if (num == 500) {
                this.oldNums = 168
            } else {
                this.oldNums = 328
            }
            this.getArea(num)
        },
        // 范围
        getArea(num) {
            const self = this
            try {
                self.myMap.remove(self.circles)
            } catch (err) {}
            self.circles = new AMap.Circle({
                center: [118.326149, 29.720121],
                radius: num, //半径
                borderWeight: 1,
                strokeColor: "rgba(74, 120, 255, 1)",
                strokeOpacity: 1,
                strokeWeight: 2,
                strokeOpacity: 0.4,
                fillOpacity: 0.5,
                // strokeStyle: 'dashed',
                strokeDasharray: [10, 10],
                // 线样式还支持 'dashed'
                fillColor: "rgba(74, 120, 255, 0.1)",
                zIndex: 50,
            })
            self.myMap.add(self.circles)
            self.myMap.setFitView()
        },
        // 就餐需求
        getMealSport() {
            const self = this
            request({
                url: "/sqyl/survery/info/findMealNeedsCount",
                method: "POST",
                data: {},
            }).then((res) => {
                // 就餐需求
                let datas = [
                    [
                        { name: "早餐", value: res.content.breakfast },
                        { name: "午餐", value: res.content.lunch },
                        { name: "晚餐", value: res.content.dinner },
                    ],
                ]
                self.getMeals(datas, "mealOrder")
                // console.log(res.content,'就餐需求')
                // self.cardInfo=res.content;
            })
        },
        // 日常餐饮
        getMealEat() {
            const self = this
            request({
                url: "/sqyl/survery/info/findDailyEatCount",
                method: "POST",
                data: {},
            }).then((res) => {
                // console.log(res.content, "日常餐饮")
                // self.cardInfo=res.content;
                let datas = [
                    [
                        { name: "自己做", value: res.content.selfDo },
                        { name: "家人做", value: res.content.familyDo },
                        { name: "外卖或外出就餐", value: res.content.goOut },
                    ],
                ]
                self.getMeals(datas, "mealDays")
            })
        },
        // 上门送餐
        getMealDelivery() {
            const self = this
            request({
                url: "/sqyl/survery/info/findIsDeliveryCount",
                method: "POST",
                data: {},
            }).then((res) => {
                // console.log(res.content, "上门送餐")
                let datas = [
                    [
                        { name: "需要", value: res.content.need },
                        { name: "不需要", value: res.content.unNeed },
                    ],
                ]
                self.getMeals(datas, "mealSend")
                // self.cardInfo=res.content;
            })
        },
        // 卡类型
        getCard() {
            const self = this
            request({
                url: "/sqyl/sxt/info/findCardTypeCount",
                method: "POST",
                data: {
                    userStatus: 1,
                },
            }).then((res) => {
                // console.log(res.content,'卡类型')
                self.cardInfo = res.content
            })
        },
        // 各年龄段
        getOlds() {
            const self = this
            request({
                url: "/sqyl/sxt/info/findAgeCount",
                method: "POST",
                data: {
                    userStatus: 1,
                },
            }).then((res) => {
                // console.log(res.content, "老人")
                self.oldInfo = res.content
            })
        },
        // 老人调查
        getMeals(datas, ids) {
            const self = this
            // console.log(datas, ids, "信息")
            let myChart = this.$echarts.init(document.getElementById(ids))
            let option
            option = {
                title: {
                    left: "center",
                    textStyle: {
                        color: "#999",
                        fontWeight: "normal",
                        fontSize: 14,
                    },
                },
                tooltip: {
                    trigger: "item",
                },
                color: ["#68D1B4", "#ED75FF", "#FFD200"],
                legend: {
                    orient: "vertical",
                    icon: "circle",
                    left: "right",
                    top: "50%",
                    textStyle: { color: "#fff" },
                },
                series: datas.map(function (data, idx) {
                    return {
                        type: "pie",
                        radius: ["40%", "60%"],
                        left: "center",
                        label: {
                            formatter: "{name|{b}}:{time|{c} 人}",
                            minMargin: 5,
                            rich: {
                                time: {
                                    fontSize: 12,
                                    // color: "#fff",
                                },
                            },
                        },
                        data: data,
                    }
                }),
            }
            option && myChart.setOption(option)
        },
        // 类型切换
        examineTap(num) {
            const self = this
            self.examineIndex = num
            if (num == 0) {
                self.$nextTick(() => {
                    self.getMealSport()
                })
            } else if (num == 1) {
                self.$nextTick(() => {
                    self.getMealDelivery()
                })
            } else {
                self.$nextTick(() => {
                    self.getMealEat()
                })
            }
        },
        // 菜品/风采
        visualizedTap(num) {
            this.visualizedIndex = num
            this.getUrl()
        },
        // 数字变数组
        changeTypes(num) {
            let str = ""
            if (num > 1000) {
                str = "0" + num
            } else {
                str = num.toString()
            }
            let arr = str.split("")
            return arr
        },
        //加载地图
        loadmap(longitude, latitude) {
            let self = this
            // return new Promise((resolve, reject) => {
            //     self.myMap = new AMap.Map("serveMap", {
            //         resizeEnable: true,
            //         zoom: 8,
            //         // postion: [longitude, latitude],
            //         mapStyle: "amap://styles/blue",
            //     })
            //     resolve()
            // })
            return new Promise((resolve, reject) => {
                self.myMap = new AMap.Map("serveMap", {
                    resizeEnable: true,
                    mapStyle: "amap://styles/darkblue",
                    zoom: 16,
                    // postion: [longitude, latitude],
                })
                if (
                    this.$store.state.orgAreaLevel == 1 ||
                    this.$store.state.orgAreaLevel == 2 ||
                    this.$store.state.orgAreaLevel == 3
                ) {
                    let cities = [this.$store.state.orgAreaName]
                    for (let i = 0; i < cities.length; i++) {
                        self.areaBG(self.myMap, cities[i])
                        self.myMap.setZoom(6)
                    }
                } else if (
                    this.$store.state.orgAreaLevel == 4 ||
                    this.$store.state.orgAreaLevel == 5
                ) {
                    // console.log("社区，街道", this.$store.state.orgId)

                    if (this.$store.state.orgId != 0) {
                        this.$http
                            .request({
                                url: "/rbac/admin/org/info/findOrgById",
                                method: "POST",
                                data: {
                                    id: this.$store.state.orgId,
                                },
                            })
                            .then((res) => {
                                var polygonArr = []
                                if (res.content.pointPosition != null) {
                                    res.content.pointPosition
                                        .split(",")
                                        .forEach((i) => {
                                            // console.log(i)
                                            polygonArr.push(i.split(":"))
                                        })
                                    self.polygon = new AMap.Polygon({
                                        map: self.myMap,
                                        strokeWeight: 1,
                                        path: polygonArr,
                                        fillOpacity: 0.3,
                                        fillColor: "#2191E6",
                                        strokeColor: "#007CDB",
                                    })
                                    let maxlng = polygonArr[0].lng
                                    for (
                                        let i = 0;
                                        i < polygonArr.length - 1;
                                        i++
                                    ) {
                                        maxlng =
                                            maxlng < polygonArr[i + 1].lng
                                                ? polygonArr[i + 1].lng
                                                : maxlng
                                    }
                                    let minlng = polygonArr[0].lng
                                    for (
                                        let i = 0;
                                        i < polygonArr.length - 1;
                                        i++
                                    ) {
                                        minlng =
                                            minlng > polygonArr[i + 1].lng
                                                ? polygonArr[i + 1].lng
                                                : minlng
                                    }
                                    let lngs =
                                        parseInt(minlng) +
                                        (parseInt(maxlng) - parseInt(minlng)) /
                                            2
                                    let maxlat = polygonArr[0].lat
                                    for (
                                        let i = 0;
                                        i < polygonArr.length - 1;
                                        i++
                                    ) {
                                        maxlat =
                                            maxlat < polygonArr[i + 1].lat
                                                ? polygonArr[i + 1].lat
                                                : maxlat
                                    }
                                    let minlat = polygonArr[0].lat
                                    for (
                                        let i = 0;
                                        i < polygonArr.length - 1;
                                        i++
                                    ) {
                                        minlat =
                                            minlat > polygonArr[i + 1].lat
                                                ? polygonArr[i + 1].lat
                                                : minlat
                                    }
                                    let lats =
                                        parseInt(minlat) +
                                        (parseInt(maxlat) - parseInt(minlat)) /
                                            2
                                    self.myMap.setZoomAndCenter(7, [lngs, lats])
                                    // self.myMap.setZoomAndCenter(14,[polygonArr[0].lng, polygonArr[0].lat])
                                    self.polygon.setMap(self.myMap)
                                }
                            })
                    }
                }
                resolve()
            })
        },
        areaBG(map, cityName) {
            // console.log(cityName, "cityName")
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                district.search(`${cityName}`, function (status, result) {
                    // 获取边界信息
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            polygons.push(polygon)
                            // console.log(polygon)
                        }
                    }
                })
            })
        },
        //获取监控链接
        // getvode() {
        //     fetch("https://open.ys7.com/api/lapp/token/get", {
        //         method: "POST", // or 'PUT'
        //         body: `appKey=${this.accessKey}&appSecret=${this.accessSecret}`,
        //         headers: {
        //             "Content-Type": "application/x-www-form-urlencoded",
        //         },
        //     })
        //         .then((res) => res.json())
        //         .then((res) => {
        //             this.control = res.data.accessToken
        //         })
        // },
        getvode() {
            this.vodelist = [
                {
                    sequence: "1",
                    channel: "1",
                    token: "1",
                },
                {
                    sequence: "1",
                    channel: "1",
                    token: "1",
                },
                {
                    sequence: "1",
                    channel: "1",
                    token: "1",
                },
            ]
            this.$http
                .request({
                    url: "/ypt/admin/monitorManagement/info/getMonitor",
                    method: "POST",
                    data: {
                        flag: 10,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content.length > 0) {
                            this.vodelist = res.content
                        } else {
                            this.vodelist = [
                                {
                                    sequence: "1",
                                    channel: "1",
                                    token: "1",
                                },
                                {
                                    sequence: "1",
                                    channel: "1",
                                    token: "1",
                                },
                            ]
                        }
                    }
                })
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        getMeal() {
            let params = {}
            post("/sqyl/admin/weeklyMenu/findTodayFoodList", params).then(
                (res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.menulist = res.content
                            for (let i = 0; i < this.menulist.length; i++) {
                                const element = this.menulist[i]
                                if (element.meal == 1) {
                                    this.breakMenu = element.foodName
                                }
                                if (element.meal == 2) {
                                    this.lunchMeun = element.foodName
                                }
                                if (element.meal == 3) {
                                    this.dinnerMeun = element.foodName
                                }
                            }
                        }
                    }
                }
            )
        },
        getPrice() {
            let params = {
                pageNo: 1,
                pageSize: -1,
            }
            post("sqyl/meauPrice/info/findList", params).then((res) => {
                if (res.code == 200) {
                    if (res.content) {
                        if (res.content.list[0].breakfastPrice) {
                            this.breakfastPrice =
                                res.content.list[0].breakfastPrice
                        } else {
                            this.breakfastPrice = ""
                        }
                        if (res.content.list[0].lunchPrice) {
                            this.lunchPrice = res.content.list[0].lunchPrice
                        } else {
                            this.lunchPrice = ""
                        }
                        if (res.content.list[0].dinnerPrice) {
                            this.dinnerPrice = res.content.list[0].dinnerPrice
                        } else {
                            this.dinnerPrice = ""
                        }
                    } else {
                    }
                }
            })
        },
        getPolicy() {
            let params = {
                pageNo: 1,
                pageSize: -1,
            }
            post("sqyl/foodAssistancePolicy/info/findList", params).then(
                (res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.zcpolicy = res.content.list[0].policy
                        } else {
                            this.zcpolicy = ""
                        }
                    }
                }
            )
        },
        getUrl() {
            let params = {
                pageNo: 1,
                pageSize: -1,
            }
            post("sqyl/admin/serviceStyle/info/findList", params).then(
                (res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.styleUrl = res.content.list
                        } else {
                            this.styleUrl = ""
                        }
                    }
                }
            )
        },
        elderlyDetails() {
            this.isMasks = true
            this.details()
        },
        details() {
            this.$http
                .request({
                    url: "/sqyl/sxt/info/findList",
                    method: "POST",
                    data: {
                        pageNo: this.query.pageNo,
                        pageSize: this.query.pageSize,
                        ...this.queryInfo,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.tableData = res.content.list
                            this.query.totol = res.content.count
                        }
                    }
                })
        },
        handleSizeChange(val) {
            this.query.pageSize = val
            this.details()
        },
        handleCurrentChange(val) {
            this.query.pageNo = val
            this.details()
        },
        QueryInfo() {
            this.details()
        },
        svsd() {
            this.isMasks = false
        },
        close() {
            this.perInfoBoxs = false
            this.eatRecord = false
        },
        diningRecord() {
            this.eatRecord = true
            this.$http
                .request({
                    url: "/sqyl/consumeRecord/info/findConsumeRecord",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.dataList = res.content
                            this.drawLine()
                        }
                    }
                })
        },
        unique(arr) {
            return Array.from(new Set(arr))
        },
        drawLine() {
            const myChart = this.$echarts.init(
                document.getElementById("myChart1")
            )
            let xData = []
            let xArr = []
            let aData = []
            let bData = []
            let cData = []
            let part = this.dataList
            part.forEach((item) => {
                xData.push(item.consumeDay)
            })
            xArr = this.unique(xData)
            xArr.forEach((item) => {
                part.forEach((it) => {
                    if (item == it.consumeDay && it.breakfastCount) {
                        aData.push(it.breakfastCount)
                    }
                    if (item == it.consumeDay && it.lunchCount) {
                        bData.push(it.lunchCount)
                    }
                    if (item == it.consumeDay && it.dinnerCount) {
                        cData.push(it.dinnerCount)
                    }
                })
            })
            // console.log(xArr, aData, bData, cData, "数据")
            var option
            option = {
                color: [
                    "#f47920",
                    "#ED75FF",
                    "#68D1B4",
                    "#8FBC8B",
                    "#483D8B",
                    "#2F4F4F",
                    "#00CED1",
                ],
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    // data: ["早餐", "午餐", "晚餐"],
                    data: ["午餐", "晚餐"],
                    textStyle: {
                        fontSize: 12,
                        color: "#fff",
                    },
                    top: "5%",
                    smooth: true,
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: xArr,
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        rotate: 320, //角度顺时针计算的
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                },
                series: [
                    // {
                    //     name: "早餐",
                    //     type: "line",
                    //     data: aData,
                    //     smooth: true,
                    // },
                    {
                        name: "午餐",
                        type: "line",
                        data: bData,
                        smooth: true,
                    },
                    {
                        name: "晚餐",
                        type: "line",
                        data: cData,
                        smooth: true,
                    },
                ],
            }

            option && myChart.setOption(option)
        },
        cancel() {
            this.oldNums = -1
            this.getArea(0)
        },
    },
}
</script>
<style scoped lang="less">
#myChart1 {
    width: 100%;
    height: 60vh;
}
// .bottompage /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
//   background: none;
// }
.bottompage /deep/ .el-pagination__total {
    color: #fff;
}
.bottompage /deep/ .el-pagination__sizes .el-input .el-input__inner {
    background: none;
    color: #fff;
}
.bottompage /deep/ .el-pagination__jump {
    color: #ffffff;
}
.gutter {
    background-color: #162a5b;
}
.perInfoBox {
    background: rgba(7, 17, 27, 0.5);
    position: fixed;
    width: 100%;
    top: 0;
    bottom: 0;
    z-index: 10000;
}
.perInfoBoxs {
    background: rgba(7, 17, 27, 0.5);
    position: fixed;
    width: 100%;
    top: 5%;
    bottom: 0;
    z-index: 2110;
}
.info-txt {
    position: relative;
    color: #fff;
    width: 45%;
    font-size: 14px;
    // overflow: scroll;
    margin: 5px auto;
    background: #28428d;
    padding-bottom: 20px;
}
.info-txt2 {
    position: relative;
    color: #fff;
    width: 50%;
    font-size: 14px;
    // overflow: scroll;
    margin: 10px auto;
    background: rgba(10, 88, 160, 0.8);
}
.intitle {
    color: #ffffff;
    font-size: 22px;
    font-weight: 200;
    margin-bottom: 20px;
    height: 40px;
    line-height: 40px;
}
.close-info {
    color: #ffffff;
    position: absolute;
    top: 5px;
    right: 20px;
    font-size: 30px;
    cursor: pointer;
}
.el-pagination.is-background .el-pager.active {
    background-color: #00c6cf;
    color: #fff;
}
.close-info {
    color: #fff;
    position: absolute;
    top: -5px;
    right: 20px;
    font-size: 40px;
    cursor: pointer;
}
.customerMain {
    // position: relative;
    // height: 100%;
    // // background: #001a65 url(../assets/imgs/topTitle.png) no-repeat center top;
    // background: #001a65;
    // background-size: 1920px 9.6vh;
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    // background: url("../assets/img/bg.png") no-repeat center center;
    background: #001a65;
    background-size: 1920px 9.6vh;
    // .quanp {
    //   right: 10px;
    //   top: 15px;
    //   position: absolute;
    //   z-index: 50;
    //   .quanp button {
    //     padding: 10px;
    //   }
    // }
    .quanp {
        width: 200px;
        height: 40px;
        // float: right;
        position: absolute;
        top: 20px;
        right: -110px;
        z-index: 100000000000000000;
        button {
            padding: 10px;
        }
    }
    .visualizedTitle {
        width: 100%;
        height: 8vh;
        background: url(../assets/imgs/titleLine.png) no-repeat center bottom;
        .defaultTitle {
            font-size: 20px;
            line-height: 7vh;
            padding-left: 14px;
            .name {
                color: #2f5ce2;
            }
            .visualizedTab {
                cursor: pointer;
                color: #4c5d94;
                &.visualizedTabCur {
                    color: #2f5ce2;
                }
            }
            .visualizedTabLine {
                width: 2px;
                background: #2f5ce6;
                height: 3vh;
                margin: 0 22px;
                display: inline-block;
                position: relative;
                top: 0.7vh;
            }
        }
    }
    .visualizedMiddle {
        top: 0vh;
        padding: 0 20px;
        position: relative;
        display: flex;
        .visualizedLeft {
            width: 25.8%;
            .videoBox {
                width: 100%;
                height: 28vh;
                overflow: scroll;
                margin: 1vh 0;
                display: flex;
                .ysopen {
                    position: relative;
                    z-index: 2000;
                    width: 500px;
                    height: 25vh;
                }
                .videoItem {
                    text-align: center;
                    line-height: 4vh;
                    color: #fff;
                    width: 100%;
                    height: 26vh;
                }
            }
            .registerBox {
                width: 100%;
                height: 18vh;
                margin: 1vh 0;
                display: flex;
                justify-content: center;
                .registerLeft {
                    text-align: center;
                    flex: 1;
                    background: url(../assets/imgs/bg.png) no-repeat center;
                    background-size: contain;
                    .muns {
                        color: #ffd200;
                        font-weight: bold;
                        font-size: 30px;
                        padding-top: 20%;
                    }
                    .name {
                        color: #e4e4e4;
                        font-size: 16px;
                        padding-top: 0px;
                    }
                }
                .registerRight {
                    width: 200px;
                    li {
                        height: 3.5vh;
                        margin-top: 1.6vh;
                        color: #a8c8ff;
                        font-size: 16px;
                        line-height: 3.5vh;
                        display: flex;
                        .name {
                            width: 80px;
                            text-align: right;
                        }
                        .nums {
                            width: 110px;
                            margin-left: 10px;
                            height: 3.5vh;
                            text-align: center;
                            color: #fff;
                            background-size: 100%;
                        }
                        .nums1 {
                            background: url(../assets/imgs/numIcon0.png)
                                no-repeat;
                        }
                        .nums2 {
                            background: url(../assets/imgs/numIcon1.png)
                                no-repeat;
                        }
                        .nums3 {
                            background: url(../assets/imgs/numIcon2.png)
                                no-repeat;
                        }
                        .nums4 {
                            background: url(../assets/imgs/numIcon3.png)
                                no-repeat;
                        }
                    }
                }
            }
            .policyBox {
                li {
                    background: rgba(104, 209, 180, 0.1);
                    border-radius: 3px;
                    color: #fff;
                    margin-top: 0.6vh;
                    line-height: 3vh;
                    padding: 6px 10px;
                }
                li span {
                    color: #ff3131;
                }
            }
        }
        .visualizedCenter {
            flex: 1;
            margin: 0 3%;
            .serveMap {
                width: 100%;
                height: 72vh;
                position: relative;
            }
            .visualizedMeals {
                display: flex;
                align-items: center;
                margin: 3vh 0 2vh;
                position: relative;
                .mealItem {
                    flex: 1;
                    line-height: 7vh;
                    text-align: center;
                    .mealTitle {
                        color: #a8c8ff;
                        font-size: 20px;
                    }
                    span {
                        margin-right: 6px;
                        border-radius: 3px;
                        display: inline-block;
                        background: #4a78ff;
                        color: #fff;
                        padding: 0 8px;
                        box-shadow: 0 0 3px #2b70e5;
                        font-size: 38px;
                    }
                    span:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
        .visualizedRight {
            width: 25.5%;
            .visualizedCard {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                .cardItem {
                    flex: 1;
                    margin-top: 2vh;
                    .cardNum {
                        min-width: 144px;
                        height: 6vh;
                        display: inline-block;
                        background: #052277;
                        box-shadow: 0 0 4px #4a78ff;
                        line-height: 6vh;
                        font-size: 24px;
                        color: #ffd200;
                        margin-top: 2px;
                    }
                    .cardName {
                        color: #a8c8ff;
                        font-size: 18px;
                        line-height: 3vh;
                        padding-top: 2vh;
                    }
                }
            }
            .visualizedTabBox {
                margin-top: 1vh;
                height: 27vh;
                .varietyMain {
                    border: 2px solid #72a6ff;
                    height: 27vh;
                    .varietyItem {
                        height: 6vh;
                        background: rgba(74, 120, 255, 0.28);
                        border-radius: 4px;
                        margin: 2.4vh 17px 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .varietyLeft {
                            line-height: 3vh;
                            height: 6vh;
                            width: 120px;
                            color: #dfefff;
                            text-align: center;
                            background: #4a78ff;
                            border-radius: 4px;
                        }
                        .varietyRight {
                            line-height: 3vh;
                            flex: 1;
                            padding-left: 10px;
                            font-size: 16px;
                            color: #fff;
                            overflow: hidden;
                            display: -webkit-box; //将元素设为盒子伸缩模型显示
                            -webkit-box-orient: vertical; //伸缩方向设为垂直方向
                            -webkit-line-clamp: 2; //超出3行隐藏，并显示省略号
                        }
                    }
                }
                .serveMain {
                    height: 27vh;
                    width: 100%;
                    /deep/.el-carousel {
                        height: 27vh;
                        width: 100%;
                        .el-carousel__container {
                            height: 27vh;
                            width: 100%;
                        }

                        img {
                            width: 100%;
                            height: 27vh;
                        }
                    }
                }
            }
            .examineTab {
                text-align: center;
                padding-top: 1vh;
                font-size: 16px;
                span {
                    cursor: pointer;
                    color: #a8c8ff;
                    display: inline-block;
                    line-height: 4vh;
                    border-radius: 4px;
                    padding: 0 10px;
                    margin-right: 10px;
                    &.examineCur {
                        background: #4a78ff;
                        color: #fff;
                    }
                }
                span:last-child {
                    margin-right: 0;
                }
            }
            .examineBox {
                margin-top: 1vh;
                height: 20vh;
                .mealFrame {
                    width: 100%;
                    height: 20vh;
                }
            }
        }
    }
}
.clearBoth {
    content: "";
    display: block;
    line-height: 0;
    clear: both;
}
.maskOpen {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2000;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    .maskContent {
        transform: translate(-50%, 50%);
        background: #fff;
        border-radius: 8px;
        padding: 10px;
        left: 50%;
        top: 30%;
        position: absolute;
        ul {
            width: 200px;
            text-align: center;
            li {
                border-bottom: 1px solid #eee;
                line-height: 40px;
                color: #666;
                cursor: pointer;
            }
            li:last-child {
                border: none;
            }
        }
    }
}
.perNamesss {
    position: absolute;
    right: 0px;
    top: 0px;
    background: #ed75ff;
    color: #fff;
    border-radius: 4px;
    z-index: 1000;
    padding: 10px 20px;
}
.perNamess {
    position: absolute;
    left: 0px;
    top: 0px;
    background: #4a78ff;
    color: #fff;
    border-radius: 4px;
    z-index: 1000;
    padding: 10px 20px;
}
.perNamess1 {
    position: absolute;
    right: 0px;
    top: 40px;
    background: #4a78ff;
    color: #fff;
    border-radius: 4px;
    z-index: 1000;
    padding: 10px 20px;
}
.registerLeft:hover {
    cursor: pointer;
}
.lable .el-input /deep/ .el-input__inner {
    background-color: rgba(255, 255, 255, 0.247);
    color: #fff;
}
.tableBox /deep/ .el-table--fit {
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.tableBox /deep/ .el-table,
.el-table__expanded-cell .is-center {
    background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}

.tableBox /deep/ .el-table tr .is-center {
    background-color: #01117b !important;
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.tableBox /deep/ .el-table--enable-row-transition .el-table__body td,
.el-table .cell .is-center {
    background-color: #01117b;
    color: #85c2ff;
    border: 1px solid #3573ad;
}
.lable .el-select /deep/ .el-input__inner {
    background-color: rgba(255, 255, 255, 0.247);
    color: #fff;
}
.info-item2 {
    border-bottom: 1px solid #085e98;
    padding: 10px 30px;
    line-height: 40px;
    // height: 633px;
    p {
        color: #c4e2ff;
    }
}
.weekBox {
    width: 90%;
    .weekTop {
        margin-top: 20px;
        display: flex;
        align-items: cneter;
        font-size: 20px;
        text-align: center;
        color: #d5eaff;
        // border-bottom: 1px solid #fff;
        line-height: 40px;
        justify-content: center;
    }
    .weekTops {
        display: flex;
        align-items: cneter;
        font-size: 13px;
        text-align: center;
        color: #fff;
        line-height: 25px;
        justify-content: center;
    }
    .weekEats {
        height: 72px;
        .weekEat {
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 24px;
            color: #fff;
            height: 24px;
            font-size: 12px;
        }
    }
    .typeName {
        width: 60px;
        position: relative;
        text-align: center;
        font-size: 12px !important;
        color: #d5eaff !important;
    }
    .weekItem {
        flex: 1;
        // font-size: 12px;
        color: #d5eaff !important;
        width: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 auto;
    }
}
.customerTop {
    img {
        width: 100%;
        height: 88px;
    }
    h1 {
        color: #deeeff;
        position: absolute;
        text-align: center;
        font-weight: bolder;
        font-size: 30px;
        left: 0;
        top: 0px;
        width: 100%;
        height: 78px;
        line-height: 78px;
        z-index: 3;
    }
    .titleFirst {
        min-width: 560px;
        position: absolute;
        width: 560px;
        // border-top: 78px solid #1e69b6;
        border-left: 40px solid transparent;
        border-right: 40px solid transparent;
        height: 0;
        left: 50%;
        top: 0;
        margin-left: -310px;
        z-index: 2;
    }
    .titleSecond {
        min-width: 620px;
        width: 620px;
        position: absolute;
        // border-top: 78px solid #103b71;
        border-left: 40px solid transparent;
        border-right: 40px solid transparent;
        height: 0;
        left: 50%;
        top: 0;
        margin-left: -340px;
    }
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
    background-color: rgba(104, 209, 180, 0.1);
    border: none;
    padding: 0;
}
</style>
<style>
.lable .el-form-item__label {
    color: #fff;
}
</style>
